import React from 'react';
import FlexView from 'react-flexview/lib';

export default function ChatMessage(props) {
	const messageClass =
		props.direction === 'sent' ? 'SentMessage' : 'ReceivedMessage';

	const sideFixed = props.direction === 'received' ? 'left' : 'right';

	// return (
	// 	<FlexView
	// 		vAlignContent="center"
	// 		hAlignContent={sideFixed}
	// 		className={`Message ${messageClass}`}
	// 	>
	// 		<p>{props.text}</p>
	// 	</FlexView>
	// );
	return (
		<FlexView
			vAlignContent="center"
			hAlignContent={sideFixed}
			className={`Message ${messageClass}`}
		>
			<p>{props.text}</p>
		</FlexView>
	);
}
